import { all, takeEvery, put, fork } from 'redux-saga/effects';
import actions from './actions';

/*
Log Sagas

TODO: update endpoints to hit TraCS log
*/

export function* widgetUpdate() {
  yield takeEvery(actions.WIDGET_UPDATE, function*({
    headerKeys,
    contentKeys,
  }) {
    yield put({
      type: actions.WIDGET_UPDATE_SUCCESS,
      headerKeys: headerKeys,
      contentKeys: contentKeys,
    });
  });
}

/*
Saga loader
*/
export default function* rootSaga() {
  yield all([fork(widgetUpdate)]);
}
